import React from "react";
import { Alert, Text, TouchableOpacity, View } from "react-native";
import * as Sentry from "@sentry/react-native";
import { useRouter } from "expo-router";
import { Trash2 } from "lucide-react-native";
import type { Channel } from "stream-chat";

import { useMessageContext } from "../../context/messaging/StreamContext";

import {
  PlaceholderChannelAvatar,
  type PlaceholderChannelAvatarProps,
  PlaceholderUseChatContext,
} from "@/schemas/messaging/stream";
import { getChannelPartner } from "@/utils/messaging";
import { isMobileApp } from "@/utils/platform";

let ChannelAvatarComponent: React.FC<PlaceholderChannelAvatarProps> =
  PlaceholderChannelAvatar;
let useChatContextHook = PlaceholderUseChatContext;
let ChannelPreviewMessengerProps: any = {}; // eslint-disable-line @typescript-eslint/no-explicit-any

if (isMobileApp()) {
  const {
    ChannelAvatar,
    useChatContext,
    ChannelPreviewMessenger,
  } = require("stream-chat-expo"); // eslint-disable-line @typescript-eslint/no-var-requires
  ChannelAvatarComponent = ChannelAvatar;
  useChatContextHook = useChatContext;
  ChannelPreviewMessengerProps = ChannelPreviewMessenger.propTypes;
}

export const ChannelListItem: React.FC<typeof ChannelPreviewMessengerProps> = (
  props,
) => {
  const { channel } = props;
  const router = useRouter();
  const { setChannel } = useMessageContext();
  const { client } = useChatContextHook();

  const handleLeaveChannel = async (): Promise<void> => {
    Alert.alert(
      "Delete Conversation",
      "Are you sure you want to delete this conversion?",
      [
        { text: "Cancel", style: "cancel" },
        {
          text: "Leave",
          style: "destructive",
          onPress: async (): Promise<void> => {
            try {
              if (client !== null && client.userID !== undefined) {
                await channel.hide();
                // await channel.removeMembers([client.userID]);
              }
            } catch (error) {
              Sentry.captureException(error);
              Alert.alert(
                "Error",
                "Failed to leave the channel. Please try again.",
              );
            }
          },
        },
      ],
    );
  };

  const handleEnterChannelScreen = async (channel: Channel): Promise<void> => {
    if (setChannel !== null && setChannel !== undefined) {
      setChannel(channel);
      router.push("/(main)/messaging/channel");
    }
  };

  const channelName = getChannelPartner(channel) || "Unknown User";

  return (
    <TouchableOpacity
      onPress={() => handleEnterChannelScreen(channel)}
      style={{
        flexDirection: "row",
        alignItems: "center",
        padding: 12,
        backgroundColor: "#FFFFFF",
      }}
    >
      <ChannelAvatarComponent channel={channel} />
      <View style={{ marginLeft: 12, flex: 1 }}>
        <Text style={{ fontWeight: "bold" }}>{channelName}</Text>
        <Text numberOfLines={1} style={{ color: "gray" }}>
          {channel.state.messages[channel.state.messages.length - 1]?.text ||
            "No messages yet"}
        </Text>
      </View>
      <TouchableOpacity onPress={handleLeaveChannel} style={{ padding: 8 }}>
        <Trash2 size={20} color="red" />
      </TouchableOpacity>
    </TouchableOpacity>
  );
};
